var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrowserOpera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14695_2707)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.70569 2.1666C10.7401 2.58701 12.3012 5.03879 12.3012 8.0007C12.3012 10.9627 10.7399 13.4146 8.70538 13.8349C9.42245 14.1898 10.205 14.3796 11.0076 14.3796C11.9412 14.3796 12.8587 14.1226 13.6778 13.6354C15.1127 12.1893 15.9999 10.1988 15.9999 8.0007C15.9999 5.8027 15.1128 3.81227 13.6782 2.36634C12.8591 1.87903 11.9416 1.62199 11.0076 1.62199C10.2051 1.62204 9.42271 1.81172 8.70569 2.1666Z",
    fill: "#FF3501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61804 15.9921C7.74463 15.9981 7.87142 16.0015 7.99918 16.0015C10.0476 16.0015 11.9157 15.2312 13.3311 13.9654C12.3933 14.5874 11.2969 14.9452 10.125 14.9452C8.21969 14.9452 6.51342 14.0001 5.36583 12.5095C4.48113 11.4652 3.90817 9.92156 3.86916 8.18923V7.81245C3.90817 6.08012 4.48118 4.53626 5.36568 3.49214C6.51347 2.00161 8.21974 1.05646 10.125 1.05646C11.2971 1.05646 12.3938 1.41428 13.3318 2.03666C11.9233 0.776607 10.0663 0.00797553 8.02945 0.000406553C8.01929 0.000406553 8.00934 5.40312e-10 7.99918 5.40312e-10C3.58052 -5.0798e-05 -0.00158691 3.58185 -0.00158691 8.00071C-0.00158691 12.2916 3.37631 15.7933 7.61804 15.9921Z",
    fill: "#FF3501"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14695_2707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserOpera);
export default __webpack_public_path__ + "static/media/browser-opera.a52ed3d225d91f62626336c72d752052.svg";
export { ForwardRef as ReactComponent };